/**
 * Before/After Image Slider Web Component
 * Handles drag interaction, touch support, and clip-path updates
 */
if (!customElements.get('before-after-image-slider')) {
  class BeforeAfterImageSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.beforeImage = null;
      this.sliderButton = null;
      this.isDragging = false;
      this.onInput = this.onInput.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
    }

    connectedCallback() {
      this.slider = this.querySelector('.ba-image-slider__drag-slider');
      this.beforeImage = this.querySelector('.ba-image-slider__image--before');
      this.sliderButton = this.querySelector('.ba-image-slider__slider-button');

      if (!this.slider || !this.beforeImage || !this.sliderButton) return;

      // Range input handler
      this.slider.addEventListener('input', this.onInput);

      // Pointer events for smooth dragging
      this.addEventListener('pointerdown', this.onPointerDown);
      document.addEventListener('pointerup', this.onPointerUp);
      document.addEventListener('pointermove', this.onPointerMove);

      // Set initial position
      this.updateSlider(50);
    }

    disconnectedCallback() {
      if (this.slider) {
        this.slider.removeEventListener('input', this.onInput);
      }
      this.removeEventListener('pointerdown', this.onPointerDown);
      document.removeEventListener('pointerup', this.onPointerUp);
      document.removeEventListener('pointermove', this.onPointerMove);
    }

    onInput(e) {
      this.updateSlider(e.target.value);
    }

    onPointerDown(e) {
      this.isDragging = true;
      this.setPointerCapture(e.pointerId);
      e.preventDefault();
    }

    onPointerUp(e) {
      this.isDragging = false;
    }

    onPointerMove(e) {
      if (!this.isDragging) return;
      const rect = this.getBoundingClientRect();
      let x = e.clientX - rect.left;
      let percentage = (x / rect.width) * 100;
      percentage = Math.max(0, Math.min(100, percentage));
      this.slider.value = percentage;
      this.updateSlider(percentage);
    }

    updateSlider(value) {
      const percent = parseFloat(value);
      // Clip before image
      this.beforeImage.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
      // Move slider button
      this.sliderButton.style.left = `${percent}%`;
    }
  }

  customElements.define('before-after-image-slider', BeforeAfterImageSlider);
}

// Add global variant change listener to update slider data dynamically
document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('change', (e) => {
    if (e.target.closest('variant-selects, variant-radios')) {
      setTimeout(() => {
        const url = new URL(window.location.href);
        const variantId = url.searchParams.get('variant');
        
        document.querySelectorAll('.shopify-section').forEach(section => {
          if (!section.querySelector('[data-ba-slider-section]')) return;
          
          const sectionId = section.id.replace('shopify-section-', '');
          let fetchUrl = window.location.pathname + '?section_id=' + sectionId;
          if (variantId) {
            fetchUrl += '&variant=' + variantId;
          }
          
          fetch(fetchUrl)
            .then(res => res.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const newContent = doc.querySelector('.afw-ba-slider-container');
              const oldContent = section.querySelector('.afw-ba-slider-container');
              
              if (newContent && oldContent) {
                oldContent.replaceWith(newContent);
              }
            })
            .catch(err => console.error('Error fetching updated section:', err));
        });
      }, 50); // slight delay to allow variant logic to update URL
    }
  });
});
